export default __webpack_public_path__ + "static/media/hero-plate2.065805ea.jpg";